import { useState } from 'react'
import { useNavigationType } from 'react-router-dom'
import { PlansOffer } from 'src/modules/payment/containers/plans-offer'
import type { UpgradeFunnelParams } from 'src/modules/payment/types/upgrade-funnel.types'

export function SubscriptionPlanTab() {
  const navigationType = useNavigationType()
  // Frozen at mount: `settings_nav` only when an in-app navigation opened the tab.
  const [params] = useState<UpgradeFunnelParams>(() => ({
    trigger: 'settings',
    source_element: navigationType === 'PUSH' ? 'settings_nav' : undefined,
  }))

  return <PlansOffer surface="plans_tab" params={params} priceSuffix="month" showCancelLink />
}
